import { IEnvironment } from '../shared/interfaces/environment.interface';

export const environment: IEnvironment = {
    base: 'https://api-dev.b2school.io/apiassets',
    wasoApi: 'https://api-dev.b2school.io/api/',
    apiKey: 'KsQbXMLDVhw9Umgub3',
    cookieDomain: 'api-dev.b2school.io',
    cookieSecure: true,
    production: false,
    mock: {
        all: false,
        enable: true,
        services: {
            auth: false,
            messaging: false,
            groups: false,
            classes: false,
            schools: false,
            users: false,
            schoolYears: false,
            boutique: false,
            cloud: false,
        },
    },
};
